import { Icon, IconButton, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCreatePriceLabel } from '@hero/hooks';
import { formatCurrency } from '@hero/utils';

import * as S from './style';

function HorizontalSkuCard({ sku, onRemove, isDeletable = true }) {
  const { t } = useTranslation();
  const { isCAActMustBeApplied } = useCreatePriceLabel({});

  const facadeImage = sku?.images?.[0]?.thumb;

  return (
    <S.HorizontalSkuCard>
      <S.FacadeImage src={facadeImage} />
      <S.CardBody>
        <S.CardName variant="body2Bold">{sku.name}</S.CardName>
        <S.CardRow>
          <Typography variant="caption2Bold" color="neutral" emphasis="400">
            {t('code') + ': '}
            <Typography variant="caption1" as="span" color="neutral" emphasis="400">
              {sku.code}
            </Typography>
          </Typography>
          <Typography variant="body2Bold">
            {formatCurrency(isCAActMustBeApplied ? sku.priceBreakdown?.display : sku.price)}
          </Typography>
        </S.CardRow>
      </S.CardBody>
      {isDeletable && (
        <IconButton variant="outlined" color="secondary" onClick={onRemove}>
          <Icon name="close" />
        </IconButton>
      )}
    </S.HorizontalSkuCard>
  );
}

HorizontalSkuCard.propTypes = {
  sku: PropTypes.object.isRequired,
  onRemove: PropTypes.func,
  isDeletable: PropTypes.bool
};

export { HorizontalSkuCard };
